function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { shallowEqual } from '@okee-uikit/react-utils';
import { ColumnType } from '../type';
import { Column } from './Column';
import { ColumnGroup } from './ColumnGroup';
export var ColumnManager = function () {
  function ColumnManager() {
    _classCallCheck(this, ColumnManager);

    this.columns = [];
    this.map = {};
    this.fixedLeftColumns = [];
    this.nonFixedColumns = [];
    this.fixedRightColumns = [];
  }

  _createClass(ColumnManager, [{
    key: "createOrUpdateColumn",
    value: function createOrUpdateColumn(options, parent) {
      var map = this.map;
      var old = map[options.key];

      if (old != null && old.getParent() === (parent || null)) {
        if (old.isGroup() && options.type === ColumnType.GROUP) {
          old.updateColumnOptions(options);
          return map[options.key];
        }

        if (!old.isGroup() && options.type === ColumnType.LEAF) {
          old.updateColumnOptions(options);
          return map[options.key];
        }
      }

      if (old) {
        old.dispose();
      }

      if (options.type === ColumnType.GROUP) {
        var group = map[options.key] = new ColumnGroup(this, options, parent);
        group.updateColumnOptions(options);
        return group;
      }

      var leaf = map[options.key] = new Column(this, options, parent);
      leaf.updateColumnOptions(options);
      return leaf;
    }
  }, {
    key: "updateColumns",
    value: function updateColumns(columns) {
      var _this = this;

      var oldColumns = this.columns;
      var newMap = {};
      var newColumns = columns.map(function (options) {
        return newMap[options.key] = _this.createOrUpdateColumn(options);
      });

      if (!shallowEqual(oldColumns, newColumns)) {
        this.columns = newColumns;
      }

      Object.keys(this.map).forEach(function (key) {
        var column = _this.map[key];

        if (column.isDisposed()) {
          delete _this.map[key];
        }
      });
      this.updateShownColumns();
    }
  }, {
    key: "getFixedLeftColumns",
    value: function getFixedLeftColumns() {
      return this.fixedLeftColumns;
    }
  }, {
    key: "getNonFixedColumns",
    value: function getNonFixedColumns() {
      return this.nonFixedColumns;
    }
  }, {
    key: "getFixedRightColumns",
    value: function getFixedRightColumns() {
      return this.fixedRightColumns;
    }
  }, {
    key: "getShownColumns",
    value: function getShownColumns() {
      return [].concat(_toConsumableArray(this.fixedLeftColumns), _toConsumableArray(this.nonFixedColumns), _toConsumableArray(this.fixedRightColumns));
    }
  }, {
    key: "getColumn",
    value: function getColumn(key) {
      return this.map[key];
    }
  }, {
    key: "getLeafColumns",
    value: function getLeafColumns() {
      var columns = [];
      this.columns.forEach(function (item) {
        if (item.isGroup()) {
          columns.push.apply(columns, _toConsumableArray(item.getLeafColumns()));
          return;
        }

        columns.push(item);
      });
      return columns;
    }
  }, {
    key: "updateShownColumns",
    value: function updateShownColumns() {
      var oldLeft = this.fixedLeftColumns;
      var oldNonFixed = this.nonFixedColumns;
      var oldRight = this.fixedRightColumns;
      var fixedLeftColumns = [];
      var nonFixedColumns = [];
      var fixedRightColumns = [];
      this.columns.forEach(function (item) {
        if (!item.isActualShow()) {
          return;
        }

        var type = item.getFixedType();

        if (type === 'left') {
          fixedLeftColumns.push(item.getKey());
          return;
        }

        if (type === 'right') {
          fixedRightColumns.push(item.getKey());
          return;
        }

        nonFixedColumns.push(item.getKey());
      });

      if (nonFixedColumns.length === 0) {
        nonFixedColumns = fixedRightColumns;
        fixedRightColumns = [];
      }

      if (nonFixedColumns.length === 0) {
        nonFixedColumns = fixedLeftColumns;
        fixedLeftColumns = [];
      }

      if (!shallowEqual(oldLeft, fixedLeftColumns)) {
        this.fixedLeftColumns = fixedLeftColumns;
      }

      if (!shallowEqual(oldNonFixed, nonFixedColumns)) {
        this.nonFixedColumns = nonFixedColumns;
      }

      if (!shallowEqual(oldRight, fixedRightColumns)) {
        this.fixedRightColumns = fixedRightColumns;
      }
    }
  }]);

  return ColumnManager;
}();